"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateGiveawayRequestToJSON = exports.UpdateGiveawayRequestFromJSONTyped = exports.UpdateGiveawayRequestFromJSON = exports.instanceOfUpdateGiveawayRequest = void 0;
var runtime_1 = require("../runtime");
var GiveawayStatus_1 = require("./GiveawayStatus");
/**
 * Check if a given object implements the UpdateGiveawayRequest interface.
 */
function instanceOfUpdateGiveawayRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateGiveawayRequest = instanceOfUpdateGiveawayRequest;
function UpdateGiveawayRequestFromJSON(json) {
    return UpdateGiveawayRequestFromJSONTyped(json, false);
}
exports.UpdateGiveawayRequestFromJSON = UpdateGiveawayRequestFromJSON;
function UpdateGiveawayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ownerId': !(0, runtime_1.exists)(json, 'ownerId') ? undefined : json['ownerId'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'actionIds': !(0, runtime_1.exists)(json, 'actionIds') ? undefined : json['actionIds'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, GiveawayStatus_1.GiveawayStatusFromJSON)(json['status']),
    };
}
exports.UpdateGiveawayRequestFromJSONTyped = UpdateGiveawayRequestFromJSONTyped;
function UpdateGiveawayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ownerId': value.ownerId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'actionIds': value.actionIds,
        'status': (0, GiveawayStatus_1.GiveawayStatusToJSON)(value.status),
    };
}
exports.UpdateGiveawayRequestToJSON = UpdateGiveawayRequestToJSON;
